import { IUser } from './../../../shared/models/user.model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VariablesService, UtilService, VwoService } from '../../../shared/services';
import { MatDialog } from '@angular/material/dialog';
import {
  CommonTalktousModalComponent
} from '../../../common/common-talktous-modal/components/common-talktous-modal/common-talktous-modal.component';
import { SignupService } from '../../../shared/services/signup/signup.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-widget-wrapper',
  templateUrl: './widget-wrapper.component.html',
  styleUrls: ['./widget-wrapper.component.scss']
})
export class WidgetWrapperComponent implements OnInit {

  @Input() filterData;
  @Input() widgetData;
  // @Input() currencyIcon;
  @Input() currency;
  @Input() isMobile;
  // @Input() myFundraisersLink;
  @Output() filtersOutput = new EventEmitter<any>();
  @Output() toggleFilterComponent = new EventEmitter<any>();
  // desktop basic btn config
  basicBtnConfig = {
    width: '160px',
    height: '48px',
    fontSize: '14px',
    letterSpacing: '-0.28px',
    borderSize: '0',
    bgColor: '#01BFBD',
    textColor: '#FCFCFC',
    boxShadow: '0px 0px 1px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.24)'
  };
  appliedFilters;
  showMobileFilters;
  resetCounter;
  isLoggedIn = false;
  generalSubs: Subscription[] = [];
  user: IUser;
  @Output() askLogin = new EventEmitter();
  signinInfo = {
    mainTitle: 'Sign in to access all 67,039 fundraisers available',
    desc: 'trusted by 9.8M contributors',
  }
  loginPopupState = false;

  constructor(
    private vars: VariablesService,
    private dialog: MatDialog,
    private util: UtilService,
    private signupService: SignupService,
    public vwo: VwoService
  ) { }

  ngOnInit() {
    this.generalSubs.push(this.vars.appliedFilters.subscribe((res: any) => {
      this.appliedFilters = res;
    }));

    this.generalSubs.push(this.vars.resetCounter.subscribe((res: any) => {
      if (res) {
        this.resetCounter = true;
      } else {
        this.resetCounter = false;
      }
    }));
    this.generalSubs.push(this.util.isLoggedIn.subscribe((res) => {
      this.isLoggedIn = res;
    }));
    this.generalSubs.push(
      this.vars.userData.subscribe((res: any) => {
        this.user = res;
      })
    );

    if (this.isMobile) {
      // mobile basic btn config
      this.basicBtnConfig = {
        width: '127px',
        height: '32px',
        fontSize: '10px',
        letterSpacing: '-0.28px',
        borderSize: '0',
        bgColor: '#01BFBD',
        textColor: '#FCFCFC',
        boxShadow: '0px 0px 1px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.24)'
      }
    }
  }

  /**Open Mobile filters component when clicked on Apply filters */
  openDialogFilter() {
    if (this.isLoggedIn) {
      this.toggleFilterComponent.emit(true);
    } else {
      this.askLogin.emit('filter');
    }
  }

  /**Scroll and focus on search box when clicked on search fundraisers */
  scrollToSearch(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
    const element: HTMLElement = document.getElementsByClassName('ais-SearchBox-input')[0] as HTMLElement;
    setTimeout(() => {
      element.focus();
    }, 1000);
  }

  // /**Hide all widget tax tooltips by default */
  // hideAllTaxTooltips() {
  //   this.widgetData.forEach((element: any) => {
  //     element.hideTaxTooltip = true;
  //   });
  // }

  resetFilters() {
    if (this.isLoggedIn) {
      this.vars.resetCounter.next(true);
      this.vars.resetFilter.next(true);
    } else {
      this.askLogin.emit('filter');
    }
  }

  // widgetReady(data) {
  //   if (this.resetCounter) {
  //     this.vars.resetCounter.next(false);
  //   }
  // }

  /*Lead call popup */
  openDialogTalkToUs() {
    this.dialog.open(CommonTalktousModalComponent, {
      maxWidth: '100vw',
      width: '519px',
      maxHeight: this.util.isMobile() ? '100vh' : 'auto',
      panelClass: 'talk-to-us-modal'
    });
  }

  /**Check if user is logged in and redirect to myDonations page accordingly */
  checkForLogin(template) {
    if (this.isLoggedIn) {
      this.redirectToDonations();
    } else {
      this.signupService.openSignUp(template, 'si', () => {
        this.redirectToDonations();
      });
    }
  }

  private redirectToDonations() {
    const entityId = this.util.getUserData()?.user_details_id;
    const url = 'individual/individual_details.php?fmd_id=' + entityId + '&pageref=donations';
    this.util.nativeNavigation(url);
  }

  onSearchClick(event) {
    if (!this.isLoggedIn) {
      this.askLogin.emit('filter');
      const target = event.target as HTMLElement;
      if (target) {
        target.blur();
      }
      event.preventDefault();
    }
  }

  openLoginPopup(event) {
    this.askLogin.emit(event);
  }
}
